import { SxProps } from '@mui/material';

/**
 * Get the styles for the popover paper
 *
 * @param shouldHaveOffset Whether the popover paper should have offset
 *
 * @returns                The styles for the popover paper
 */
export const getPaperStyles = (shouldHaveOffset: boolean): SxProps => ({
  '&:focus-visible': {
    boxShadow: 'none',
  },
  marginTop: shouldHaveOffset ? 'var(--spacing-small)' : '0',
});
